import { render, staticRenderFns } from "./BtnAtualizarCronogramaRecebimento.vue?vue&type=template&id=a38ad3a0&"
import script from "./BtnAtualizarCronogramaRecebimento.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarCronogramaRecebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports